import {AttrsSchema, Component} from 'panel';
import copy from 'clipboard-copy';

import {reporter} from 'common/report/error-reporting';
import {Button, ButtonJsxProps} from 'common/components/button';
import {ToastType} from 'common/components/toast/types';
import {addToast} from 'common/components/toast-area/toast-manager';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {CopyType} from './types';
import {template} from './template';
import css from './index.inline.styl';

interface CopyToClipboardButtonJsxProps extends ButtonJsxProps {
  attrs: {
    'copy-type'?: CopyType;
    value: string;
  } & ButtonJsxProps['attrs'];
}

export class CopyToClipboardButton extends Component<EmptyObj, CopyToClipboardButtonJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<CopyToClipboardButtonJsxProps['attrs']> {
    return {
      ...Button.attrsSchema,
      'copy-type': {type: `string`, enum: Object.values(CopyType), default: CopyType.Copy},
      value: {
        description: `The value to be copied`,
        type: `string`,
      },
    };
  }

  get config() {
    return {
      useShadowDom: true,
      css,
      template,
      helpers: {
        copyValue: async () => {
          try {
            await copy(this.attr(`value`));
            addToast({
              type: ToastType.SUCCESS,
              message: this.attr(`copy-type`) === CopyType.Link ? `URL Copied!` : `Copied!`,
            });
          } catch (err) {
            reporter.error(err);
            addToast({
              type: ToastType.SUCCESS,
              message:
                this.attr(`copy-type`) === CopyType.Link
                  ? `Something went wrong copying the URL`
                  : `Something went wrong copying`,
            });
          }
        },
      },
    };
  }
}

export const CopyToClipboardButtonEl = defineAndMakeJsxFactory<CopyToClipboardButtonJsxProps>(
  `mp-copy-to-clipboard-button`,
  CopyToClipboardButton,
);
export const CopyToClipboardButtonReact = panel2react<CopyToClipboardButtonJsxProps>(
  `mp-copy-to-clipboard-button`,
  CopyToClipboardButton,
);
